<script setup>
import '@campact/camper/core/CmprCheckboxControl.css';
import { CMPR_INTERACT_EVENT, dispatchCmprEvent } from '@campact/camper/utils';

const model = defineModel({ default: false }); // eslint-disable-line vue/require-prop-types

function dispatchCmprCheckboxChange({ target }) {
  dispatchCmprEvent(target, CMPR_INTERACT_EVENT, {
    camperWebComponent: 'cmpr-checkbox',
    event: 'cmpr-checkbox-change',
    value: target.checked,
  });
}
</script>

<template>
  <input
    v-model="model"
    class="cmpr-checkbox-control__input"
    type="checkbox"
    @change="dispatchCmprCheckboxChange($event)"
  >
</template>
